import React from "react";
import ContactInfo from "./contact/ContactInfo";
import ContactForm from "./contact/ContactForm";
import { useContactForm } from "../hooks/useContactForm";

export default function Contact() {
  const { form, submitting, onChange, submit } = useContactForm();

  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <ContactInfo />
        </div>
        <ContactForm form={form} submitting={submitting} onChange={onChange} onSubmit={submit} />
      </div>
    </section>
  );
}
